<template>
  <div class="content-body" id="tender">      
       
    <div class="row match-height">
		  <div class="col-md-12"> 
               <!-- start logist view                      -->
              <div class="card" v-if="userRole == 'admin'">
                    <div class="card-header">
                        <h3 class="card-title"><i class="icon-price-tags"></i> {{$t('titles.history')}}</h3>
                        
                        <div class="heading-elements">    
                            <button  data-toggle="tooltip" data-html="true" :title="$t('tender.button.update')" type="button" class="btn btn-sm btn-icon btn-outline-warning ex-button" @click="getAllTender()"><font-awesome-icon icon="sync" class="cursor warning"  /><span class="btn-desc">{{$t('tender.button.update')}}</span></button>                       
                            <!-- <button v-if="this.$store.getUserRoleAdmin" type="button" class="btn btn-warning"  data-toggle="modal" data-target="#modaNewTender" @click="newTenderModal = true">
                                <i style="color: #FFFFFF" class="icon-plus2"></i>
                            </button>
                            <span @click="changeView('table')" class="view-svicher"><i style="color: #000" class="icon icon-table"></i></span>
                            <span @click="changeView('card')" class="view-svicher"><i style="color: #000" class="icon icon-file-text"></i></span> -->
                        </div>
                    </div>
                    <div class="card-body">                                               
                  
                        <div class="row p-1" ref="desc"  id="desc" v-if="descTablesData">
                            <div class="d-flex flex-row-reverse justify-content-and"  >
                                
                                <div class="">
                                    <span class="link " @click="descTablesData = !descTablesData"><font-awesome-icon class="sicon" icon="window-close" /></span>
                                </div>
                            
                            </div>
                            <div class="rate-des px-2" >
                                 <ul class="list-inline">
                                    <li class="list-inline-item"><b>{{ $t('tender.table.number')}}:</b> <span class="order-desc">{{descTablesData.number}}</span></li>
                                    <li class="list-inline-item"><b>{{ $t('tender.table.date')}}:</b> <span class="order-desc">{{descTablesData.dateDoc}}</span></li>
                                    <li class="list-inline-item"><b>{{ $t('tender.table.price')}}:</b> <span v-if="descTablesData.rate" class="text-center  "><span class="tag tag-success">{{descTablesData.rate}}&nbsp;{{descTablesData.currency}}</span></span></li>
  
                                </ul>
                                <ul class="list-inline">
                                    <li class="list-inline-item"><b>{{ $t('table.typeTS')}}:</b> <span class="order-desc">{{descTablesData.volume}}</span></li>
                                    <li class="list-inline-item"><b>{{ $t('table.cargo')}}:</b> <span class="order-desc">{{descTablesData.cargo}}</span></li>
                                    <li class="list-inline-item"><b>{{ $t('tender.table.downloadType')}}:</b><span class="order-desc">{{descTablesData.typeBoot}}</span></li>
                                    <!-- <li class="list-inline-item"><b>{{ $t('tender.table.сonditions')}}:</b> </b> <span class="order-desc">{{descTablesData.сonditions}}</span></li> -->
                                </ul>
                                 <ul class="list-inline">                                    
                                    <li class="list-inline-item"><b>{{ $t('tender.table.сonditions')}}:</b><span class="order-desc">{{descTablesData.сonditions}}</span></li>
                                </ul>
                            </div>

                            
                            <div class="col-md-12" v-if="descTablesData && descTablesData.listRates.length > 0">
                                 <div class="main-tables mobileTbl table-responsive" >
                                    <table class="table table-hover mb-0 loading" cellspacing="0" >
                                        <thead>
                                            <tr>     
                                                <th style="vertical-align: middle;">{{ $t('titles.roles.client') }}</th>                                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.rate') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.coments') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.persone') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('users.table.email') }}</th>                                         
                                                <th style="vertical-align: middle;">{{ $t('users.table.phone') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.winner') }}</th>                           
                                            </tr>
                                        </thead>                                                       
                                        <tbody>                              
                                            <tr class="marginTR" v-for="(item,index) in descTablesData.listRates" :key="index"> 
                                                <td :data-title="$t('titles.roles.client')"> {{item.client}}  </td>                                                                                    
                                                <td :data-title="$t('tender.table.cost')"><span v-if="item.cost" class="text-center tag " :class="getTrTypeClass(item)">{{item.cost}}&nbsp;{{item.currency}}</span></td>
                                                <td :data-title="$t('tender.table.coments')"> {{item.comment}}  </td>   
                                                <td :data-title="$t('tender.table.persone')"> {{item.persone}}  </td>   
                                                <td :data-title="$t('users.table.email')"> {{item.email}}  </td>   
                                                <td :data-title="$t('users.table.phone')"> {{item.mobile}}  </td> 
                                                <td  :data-title="$t('tender.table.downloadType')">
                                                    <div class="d-flex justify-content-center">
                                                        <font-awesome-icon v-if="item.win" class="sicon" icon="check" />
                                                    </div>                                                    
                                                </td>
                                                
                                            </tr>   
                                        </tbody>
                                    </table>
                              </div>
                        <!-- ____________________and main tables -->
                               
                        </div>


                        </div>
                        <div class="container-fluid">
                            <div class="row" style="padding-left:20px">
                                <div class="col-md-12">
                                    <fieldset class="position-relative">
                                        <input type="text" class="form-control form-control input" placeholder="" v-model="filterStr" >
                                        <div class="form-control-position" style="top:13px; right:10px;">
                                            <i class="icon-search4 font-medium-4"></i>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div> 
                        
                         <!-- ______________________________________main-tables    -->
                        <div class="main-tables mobileTbl table-responsive" >
                                <table class="table table-hover mb-0 loading" cellspacing="0" >
                                    <thead>
                                        <tr>     
                                            <th style="vertical-align: middle;">{{ $t('tender.table.number') }}</th>                                                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.date') }}</th>                                           
                                            <!-- <th style="vertical-align: middle;">{{ $t('tender.table.downloadAdress') }}</th>                                            -->
                                            <th style="vertical-align: middle;">{{ $t('tender.table.deliveryAdress') }}</th>                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.label.trType') }}</th>                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.label.trDirection') }}</th>                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.table.price') }}</th>                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.countOfRate') }}</th>                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.responsible') }}</th>                           
                                            <th style="vertical-align: middle;"></th>                           
                                        </tr>
                                    </thead>                                                       
                                    <tbody>                              
                                        <tr class="marginTR" v-for="(item,index) in paginatedData" :key="index"> 
                                            <td :data-title="$t('tender.table.number')"> {{item.number}}  </td>
                                            <td :data-title="$t('tender.table.date')"> {{item.dateDoc}}</td>                                            
                                            <!-- <td  :data-title="$t('tender.table.downloadAdress')">{{item.loadingAdress}}</td> -->
                                            <td  :data-title="$t('tender.table.deliveryAdress')">{{item.deliveryAdress}}</td>                                           
                                            <td  :data-title="$t('tender.label.trDirection')">{{item.typeTransport}}</td>                                           
                                            <td  :data-title="$t('tender.label.trType')">{{item.typeOpetation}}</td>                                  
                                            <td  :data-title="$t('tender.table.price')"><span v-if="item.cost" class="text-center  ">{{item.cost}}&nbsp;{{item.currency}}</span></td>
                                            <td  :data-title="$t('tender.table.additionally')">{{item.count}}</td>  
                                            <td  :data-title="$t('tender.table.responsible')">{{item.responsible}}</td>  
                                            <td> <a href="" ></a><font-awesome-icon icon="info" class="cursor"  @click="goToRef(item)"/> </td> 
                                        </tr>   
                                    </tbody>
                                </table>
                        </div>
                        <!-- ____________________and main tables -->
                        <div v-if="pageCount > 1" class="" style="text-align: center;">
                            <ul class="pagination">
                                <li class="page-item" v-if="pageNumber > 0">
                                    <a class="page-link" @click="pageNumber--" ><i class="icon-arrow-left2"></i></a>
                                </li>
                                
                                <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                                    <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                                    <a v-else class="page-link" :id="index">{{page}}</a>
                                </li>
                                
                                <li class="page-item" v-if="pageNumber < pageCount - 1">
                                    <a class="page-link"  @click="pageNumber++"><i class="icon-arrow-right2"></i></a>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
                 </div>
                        <!-- and logist view                        -->
                   
             

               <!-- view as client      -->
                <div class="card" v-if="userRole == 'client'">
                    <div class="card-header">
                        <h3 class="card-title"><i class="icon-price-tags"></i> {{$t('titles.history')}}</h3>
                        <div class="heading-elements">     
                            <button  data-toggle="tooltip" data-html="true" :title="$t('tender.button.update')" type="button" class="btn btn-sm btn-icon btn-outline-warning ex-button" @click="getAllTender()"><font-awesome-icon icon="sync" class="cursor warning"  /><span class="btn-desc">{{$t('tender.button.update')}}</span></button>                      
                            <!-- <button v-if="this.$store.getUserRoleAdmin" type="button" class="btn btn-warning"  data-toggle="modal" data-target="#modaNewTender" @click="newTenderModal = true">
                                <i style="color: #FFFFFF" class="icon-plus2"></i>
                            </button>
                            <span @click="changeView('table')" class="view-svicher"><i style="color: #000" class="icon icon-table"></i></span>
                            <span @click="changeView('card')" class="view-svicher"><i style="color: #000" class="icon icon-file-text"></i></span> -->
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 col-sm-12">
                                <!-- <modalEq :title="modalTitle" :methodId="chVarEq" :final_func="closeEqChoose" ></modalEq> --> 
                            </div>
                        </div>
                        
                        <div class="container-fluid">
                            <div class="row" style="padding-left:20px">
                                <div class="col-md-12">
                                    <fieldset class="position-relative">
                                        <input type="text" class="form-control form-control input" placeholder="" v-model="filterStr" >
                                        <div class="form-control-position" style="top:13px; right:10px;">
                                            <i class="icon-search4 font-medium-4"></i>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div> 

                         <!-- start user view --> 
                        <div class="card-block pt-0"  >                          
                            <div class="row" style="padding-left:7px">
                                <div class="col-md-12" style="justify-content: center !important;">
                                    <div v-for="(st, index) in tender.statuses" :key="index" class="badge hand" :class="$t('tender.reviewStatus.' + st.id + '.class')"  @click="filtrClick(st)" style="margin-left: 1%; margin-bottom: 1%;">
                                        <i :class="[st.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i>
                                        <span style="bagraund-color:#000">{{ $t('tender.reviewStatus.' + st.id + '.title') }}</span>
                                    </div>
                                </div>
                            </div>  
                           
                        <!-- ______________________________________main-tables    -->
                        <div class="main-tables mobileTbl table-responsive" v-if="viewType">
                                <table class="table table-hover mb-0 loading" cellspacing="0" >
                                    <thead>
                                        <tr>     
                                            <th style="vertical-align: middle;">{{ $t('tender.table.id') }}</th>                                                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.status') }}</th>                                                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.downloadAdress') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.downloadDate') }}</th>                                                                                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.table.productWeight') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.deliveryAdress') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.deliveryDate') }}</th> 
                                            <th style="vertical-align: middle;">{{ $t('tender.table.price') }}</th> 
                                            <th style="vertical-align: middle;"></th>                        
                                        </tr>
                                    </thead>                                                       
                                    <tbody>                              
                                        <tr class="marginTR" v-for="(item,index) in paginatedData" :key="index">                                           
                                            <td :data-title="$t('tender.table.id')"> {{item.number}}</td>   
                                            <td :data-title="$t('tender.table.status')"> <span class="badge" :class="$t('tender.reviewStatus.' + item.status + '.class')">{{ $t('tender.reviewStatus.' + item.status + '.title') }}</span>  </td>
                                            <td :data-title="$t('tender.table.date')"> {{item.arrayLoading[0].loadingAdress}}</td>                                            
                                            <td  :data-title="$t('tender.table.downloadDate')">{{item.arrayLoading[0].loadingDate}}</td>
                                            <td  :data-title="$t('tender.table.productWeight')">{{item.arrayLoading[0].Weight}}</td>
                                            <td  :data-title="$t('tender.table.deliveryAdress')">{{item.arrayDelivery[0].deliveryAdress}}</td>
                                            <td  :data-title="$t('tender.table.deliveryDate')">{{item.arrayDelivery[0].deliveryDate}}</td>
                                            <td  :data-title="$t('tender.table.price')"><span v-if="item.cost" class="text-center badge prise ">{{item.cost}}&nbsp;{{item.currency}}</span></td>
                                            <td  :data-title="$t('tender.table.downloadType')"><button v-if="item.status ==1 && !item.userRate" class="btn btn-success btn-block mb-2 mt-1" type="button" data-toggle="modal" data-target="#modalEq" @click="showmodal(item.id)">
                                                            {{$t('tender.button.confirm')}}
                                                        </button></td>
                                        </tr>   
                                    </tbody>
                                </table>



                        </div>
                        <!-- ____________________and main tables -->
                        <!-- ----------------------main list-----------------------     -->
                         <div class="main-list" v-if="!viewType">
                            <ul>
                                <li  v-for="(item,index) in paginatedData" :key="index">
                                    <div class="row" >
                                        <div class="col-md-8 col-sm-8">
                                            <span><b>{{$t('tender.table.id')}}:</b>  {{item.number}}</span><br/>
                                            <span><b>{{$t('tender.table.status')}}:</b> <span class="badge" :class="$t('tender.reviewStatus.' + item.status + '.class')">{{ $t('tender.reviewStatus.' + item.status + '.title') }}</span>                                 
                                            </span><br/>
                                            <span><b>{{$t('tender.table.coments')}}:</b>  {{item.comment}}</span>    
                                        </div>
                                        <div class="col-md-4 col-sm-4">
                                            <div class="d-flex flex-row-reverse prise-block">
                                                <div>
                                                    <div class="justify-content-start">
                                                        <span v-if="item.cost"><b>{{$t('tender.table.price')}}:</b></span> <span v-if="item.cost" class="text-center badge prise">{{item.cost}}&nbsp;{{item.currency}}</span> <br/>                                            
                                                    </div>
                                                    <div class="justify-content-start mt-1" v-if="$store.getters.getUserRoleClient && item.userRate">
                                                        <span ><b>{{$t('tender.table.userRate')}}:</b></span> <span  class="text-center badge prise">{{item.userRate}}&nbsp;{{item.currency}}</span> <br/>  
                                                    </div>                                                    
                                                </div>
                                            </div>                                             
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 loading">
                                                <div class="mobileTbl table-responsive ">
                                                    <span class="table-head">{{ $t('tender.label.loadPoint') }}</span>
                                                    <table class="table table-hover mb-0 loading" cellspacing="0" >
                                                        <thead>
                                                            <tr>                                                                
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.adress') }}</th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.date') }}</th> 
                                                                <th v-if="item.arrayLoading[0].customsCrossing" style="vertical-align: middle;">{{ $t('tender.table.customsCrossing') }}</th>                                                                                                                         
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.productWeight') }}</th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.typeOfCar') }}</th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.downloadType') }}</th>                          
                                                            </tr>
                                                        </thead>                                                       
                                                        <tbody>                              
                                                            <tr class="marginTR" v-for="(sitem,sindex) in item.arrayLoading" :key="sindex"> 
                                                                <td :data-title="$t('tender.table.download')"> {{sitem.loadingAdress}}</td>
                                                                <td :data-title="$t('tender.table.date')"> {{sitem.loadingDate}}</td>
                                                                <td v-if="sitem.customsCrossing"  :data-title="$t('tender.table.customsCrossing')">{{sitem.customsCrossing}}</td>
                                                                <td  :data-title="$t('tender.table.productWeight')">{{sitem.Weight}}</td>
                                                                <td  :data-title="$t('tender.table.typeOfCar')">{{sitem.typeOfCar}}</td>
                                                                <td  :data-title="$t('tender.table.downloadType')">{{sitem.loadingType}}</td>
                                                            </tr>   
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>


                                            <div class="col-md-12 delivery">
                                                <div class="mobileTbl table-responsive">
                                                    <span class="table-head">{{ $t('tender.label.deliveryPoint') }}</span>
                                                    <table class="table table-hover mb-0 delivery" cellspacing="0" >
                                                        <thead>
                                                            <tr>                                                               
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.adress') }}</th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.date') }}</th>                                                              
                                                            </tr>
                                                        </thead>                                                       
                                                        <tbody>                              
                                                            <tr class="marginTR" v-for="(delivery,dindex) in item.arrayDelivery" :key="dindex">                                                                        
                                                                <td :data-title="$t('tender.table.delivery')">
                                                                    {{delivery.deliveryAdress}}                                                                           
                                                                </td> 
                                                                    <td :data-title="$t('tender.table.deliveryDate')">
                                                                    {{delivery.deliveryDate}}                                                                          
                                                                </td>                                      
                                                            </tr> 
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        
                                    </div>

                                </li>
                            </ul>
                            
                        </div>
                        <!-- ----------------------and main list-----------------------     -->
                       
                        <div v-if="pageCount > 1" class="" style="text-align: center;">
                            <ul class="pagination">
                                <li class="page-item" v-if="pageNumber > 0">
                                    <a class="page-link" @click="pageNumber--" ><i class="icon-arrow-left2"></i></a>
                                </li>
                                
                                <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                                    <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                                    <a v-else class="page-link" :id="index">{{page}}</a>
                                </li>
                                
                                <li class="page-item" v-if="pageNumber < pageCount - 1">
                                    <a class="page-link"  @click="pageNumber++"><i class="icon-arrow-right2"></i></a>
                                </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
  </div> 
</template>
<script>
//import json from "../structure.json";
  export default {
    name: "transport_tender",
    components: {           
        },
    data(){
      return{
        descTablesData:null,
        viewTable:false,
        listOfTender:{},
        selecteadTender: {},
        newTenderModal:false,
        chVarEq: null,
        showVars: false,
        user_rate:null,
        user_rate_currency:null,        
        modalTitle:"Підтвердити участь",
        filterStr: "",
        pageNumber: 0,
        direction: 'asc',
        classSort: 'icon-sort-amount-asc',
        boolDir: true,
        sortKey: '',
        size:10,
        paggSize:5,
        tender: {
          typeOfTansportationVal: null,
          statuses:[
            {name: 'statuses.all', value: '', id: 0, checked: true},
            {name: 'statuses.lost',value: 'lost', id: 1, checked: false},
            {name: "statuses.win", value: "win", id: 2, checked: false},
            {name: "statuses.notInterest", value: "notInterest", id: 3, checked: false},
            {name: "statuses.canseled", value: "canseled", id: 6, checked: false},
          ],
            choosen:[
                {name: 'statuses.all', value: '', id: 0, checked: true},
            ]   
        },
        newTender:{
            type:null,
            price:null,
            сurrency:null,
            children:[],
        },
       newTenderChildren:{
           downloadAdress:null,
           downloadDate:null,
           deliveryAdress:null,
           deliveryDate:null,
           productWeight:null,
           typeOfCar:null,
           downloadType:null
       } 
      }
    },
    methods: { 
         getTrTypeClass(item){
             if (item && item.win){
                 return "tag-success"    
             }
           
               

        },      
        getAllTender(){                            
                let dataRequest = {guidClient: null};
                dataRequest.guidClient = this.$store.state.guidClient;
                dataRequest.variant = 2;
                this.makeQuery("/portal/getlisttender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res.data.result){ 
                        this.listOfTender = res.data.data                    
                    //    console.log(res.data.data);
                    }
                });           
        },

        filtrClick(item){
                //  this.tender.filterchoosen = [],
                // this.tender.statuses[index].checkeded = !this.tender.statuses[index].checkeded;
                // index != 0 ? this.tender.statuses[0].checkeded = false : this.tender.statuses[0].checkeded = true;

                // this.tender.filterchoosen.push(item.id)
                let arr = this.tender;                
                arr.choosen = [];
                let notall = false;
                item.checked = !item.checked;
                let bool = item.checked;

                let itemAll =  arr.statuses[0];

                if(item == itemAll){
                    for (let i = 0; i <  arr.statuses.length; i++){
                        if( arr.statuses[i] != item){ arr.statuses[i].checked = false;}
                    }
                } else {
                    if(itemAll.checked == true){
                        item.checked = true;
                        for (let i = 0; i <  arr.statuses.length; i++) {
                            if( arr.statuses[i] != item){
                                 arr.statuses[i].checked = false;
                            }
                            
                        }
                    } else {
                        for (let i = 0; i <  arr.statuses.length; i++) {
                            if(( arr.statuses[i].checked == false) && ( arr.statuses[i] != itemAll)){
                                notall = true;
                            }
                            
                        }

                        console.log(notall)
                        if(notall == true){
                            itemAll.checked = false;
                        } else {
                            itemAll.checked = true;
 
                            for (let i = 0; i <  arr.statuses.length; i++) {
                                if( arr.statuses[i] != itemAll){
                                     arr.statuses[i].checked = false;
                                }
                            }
                        }
                    }
                }

                //нажаті
                for (let i = 0; i <  arr.statuses.length; i++) {
                    if( arr.statuses[i].checked == true){
                        arr.choosen.push( arr.statuses[i]);
                    }
                }
                if(arr.choosen.length < 1){
                    arr.statuses[0].checked = true;
                    arr.choosen.push(arr.statuses[0]);
                }

                
            },
        showmodal(id){
        console.log(id);
        this.chVarEq = 1; 
        this.$store.state.modalBody = true; 
        // this.showVars = false;
        this.selecteadTender = _.find(this.listOfTender, o => o.id == id);



        
      },
      closeEqChoose(){
                this.chVarEq = null;
            },
      sortData(key){
                if (this.sortKey == key){
                    this.boolDir = !this.boolDir;
                } else {
                    this.boolDir = false;
                }
                if (this.boolDir){
                    this.direction = 'asc';
                    this.classSort = 'icon-sort-amount-asc';
                } else {
                    this.direction = 'desc';
                    this.classSort = 'icon-sort-amount-desc';
                }

                this.sortKey = key;
            },
             changeView(data){
            // let cval = this.$store.getters.getViewType;
            // if (cval == "card"){this.$store.commit('setViewType', "table");  }
            this.$store.commit('setViewType', data);            
        },
         goToRef(item){
        console.log(item)
        // this.descTablesData = item;
        this.anchorTo("card-title")
        this.getTenderDesc(item.guidDoc)
    //   $('#collapse41').collapse('hide')
    },
    getTenderDesc(id){
            let dataRequest = {
                guidClient: this.$store.state.guidClient,
                guidDoc:id,               
                };
            this.makeQuery("/portal/getInfoTender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res != null){ 
                        if(res.data.data ) {this.descTablesData = res.data.data }                                                    
                     
                    }
                });

        },
    },
    computed:{
         viewType(){
            return this.$store.getters.getViewType == "table" ? true : false
        },
        userRole(){
            if(this.$store.getters.getUserRoleAdmin || this.$store.getters.getUserRoleLogist){
                return  "admin"    
            }
            else return "client"
           
        },
      listFiltered: function(){
                let find = this.filterStr.toLowerCase();
                let filterBystatus = this.tender.statuses;
                let found1 = false;
                let found2 = false;
                this.pageNumber = 0;
               if (!_.isEmpty(this.listOfTender)){
                   return this.listOfTender.filter(item => {
                    found1 = false;
                    found2 = false;
                    if( (find == '') || ((item.id != null) && (item.id.toLowerCase().indexOf(find) > -1))
                    || ((item.number != null) && (item.number.toLowerCase().indexOf(find) > -1))
                    || ((item.typeOpetation != null) && (item.typeOpetation.toLowerCase().indexOf(find) > -1))
                    || ((item.typeTransport != null) && (item.typeTransport.toLowerCase().indexOf(find) > -1))
                    || ((item.loadingAdress != null) && (item.loadingAdress.toLowerCase().indexOf(find) > -1))
                    || ((item.responsible != null) && (item.responsible.toLowerCase().indexOf(find) > -1))
                    || ((item.deliveryAdress != null) && (item.deliveryAdress.toLowerCase().indexOf(find) > -1)) ){
                        found1 = true;
                    }
                    
                    for (let i = 0; i < this.tender.choosen.length; i++){
                        if( (this.tender.choosen[i].id == 0) || ((item.status != null) && (item.status == this.tender.choosen[i].id))){
                            found2 = true; 
                            break;
                        }
                    }
                    if(found1 && found2){
                        return item;
                    }
                })
                }
                else return {}
              
                
            },            
            pageCount(){
                let l = this.listFiltered.length, s = this.size;
                return Math.ceil(l/s);
            },
            pages: function(){
                let arr = [];
                for (let i = 0; i < this.pageCount; i++) { 
                    arr[i] = i + 1;
                }
                let divider = Math.trunc(this.paggSize/2);
                let start = this.pageNumber - divider;
                let end = this.pageNumber + divider + 1;
                if (start < 0) {
                    start = 0;
                }
                let final_arr = arr.slice(start,end);
                if ((start + 1) > arr[0]){
                    final_arr.unshift('...');
                }
                if(end < arr[arr.length - 1]){
                    final_arr.push('...');
                }
                return final_arr;
            },
            paginatedData(){
                if (this.sortedData.length > 0){
                    const start = this.pageNumber * this.size,
                        end = start + this.size;
                    return this.sortedData.slice(start, end);
                }
            },
            sortedData: function () {
                return _.orderBy(this.listFiltered, this.sortKey, this.direction);
            },
    },
    created() {
        
    },
    mounted(){
        // this.columns['0']['label'] = this.$t('equipm.table.codeModel')
        this.getAllTender();
    }
  }
</script>

<style scoped>
.tag {color: #000;}
#desc {
    background-color: rgb(250, 250, 250);
    margin: 3px 20px;
}
#tender{
font-family: Inter,sans-serif!important;
font-size: 0.8rem;
}
#tender fieldset {
  padding: 10px;
}
.table-responsive {
    padding-top: 10px;
}
.mobileTbl th{
     /* border-top: 1px solid #999; */
     border-top:0px;
}

.main-list ul li {
 list-style: none;
 border: 3px solid #999;
 background-color: #fffbfb;
 padding: 20px 20px;
 margin: 10px 10px;
 margin-top: 20px;;
}
.main-list ul {
    padding-left: 10px;
}
.main-list ul:first-child {
    margin-top: 30px;
}
.loading {
    margin-top: 5px;
}


.delivery{
    margin-top: 15px;

}

.table-head {
    font-size: 0.8rem;
    border-radius: 0;
    padding: 10px 0px;
    font-weight: 600; 
    margin-left: 15px;
    color: black;
    border-bottom: 1px solid #999;
    /* padding-left: 5px; */
    /* display: block;
    border: 1px solid #999;
    padding: 10px 10px; */
    


}
.prise {
    padding: 10px 10px;
     border: 1px solid #999;
     float: right;
     margin-left: 5px;

}
.view-svicher {
    cursor: pointer;
}
.cursor {
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.btn-desc {
    margin: 0 2px;
    line-height: 2.1;
}
@media only screen and (max-width: 800px) {
.table-hover {
    padding: 10px 5px;
}
.prise {
    padding: 5px 5px;   
    float: none;
    margin-left: 1px;
}
.card-body {
    padding: 0px;
}
.prise-block {
    float: left;
}
}
</style> 


// WEBPACK FOOTER //
// src/pages/User_tender.vue